import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Tooltip } from "@mui/material";
import Modals from "../../components/common/Modal";
import "../../assets/css/englishAuction.css";
import { ThreeDots } from "react-loader-spinner";
import * as actionUrl from "../../store/actions";
function BidHistoryPage({ open, setOpen, modalRight }) {
  const [viewModal, setViewModal] = useState(false);
  const [isDownloading, setisDownloading] = useState(false);
  const [searchAuctioneer, setsearchAuctioneer] = useState("");
  const [searchLotNo, setsearchLotNo] = useState("");
  const [searchSessionTime, setsearchSessionTime] = useState("");
  const [searchSessionType, setsearchSessionType] = useState("");
  const roleCode = atob(localStorage.getItem("argument6"));
  const auctionCenterIdFromURI =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[4]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[4]
      )
    : "";
const userid = atob(sessionStorage.getItem("argument2"));
  const bidHistoryData = useSelector(
    (state) => state?.bidHistoryReducer?.bidHistoryData?.responseData
  );
  const bidHistoryExportData = useSelector(
    (state) => state?.bidHistoryReducer?.exportData?.responseData
  );
  const loading = useSelector((state) => state?.bidHistoryReducer?.loading);
  const viewBidHistoryData = useSelector(
    (state) => state?.bidHistoryReducer?.viewBidHistoryData?.responseData
  );
  const userDropdownData = useSelector(
    (state) => state?.bidHistoryReducer?.dropdownData?.responseData
  );
  const viewLoading = useSelector(
    (state) => state?.bidHistoryReducer?.viewLoading
  );
  const dispatch = useDispatch();
  const [auctioneerList, setauctioneerList] = useState([]);
  const [lotNoList, setlotNoList] = useState([]);
  const [sessionTimeList, setsessionTimeList] = useState([]);
  const handleClearSearch = () => {
    setsearchAuctioneer("");
    setsearchLotNo("");
    setsearchSessionTime("");
    setsearchSessionType("");
    dispatch(
        actionUrl.fetchBidHistoryRequest({
          auctioneer: null,
          sessionType: null,
          sessionTime: null,
          lotNo: null,
          auctioneerId: searchAuctioneer,
          isExport: 0,
          exportType: "string",
          userRoleCode : roleCode,
          userId : userid,
          auctionCenterId :auctionCenterIdFromURI
        })
      );
    
  };
  const handleSearch = () => {
    dispatch(
        actionUrl.fetchBidHistoryRequest({
          sessionType: searchSessionType,
          sessionTime: searchSessionTime,
          lotNo: searchLotNo,
          auctioneerId: searchAuctioneer,
          isExport: 0,
          exportType: "",
          userRoleCode : roleCode,
          userId : userid,
          auctionCenterId :auctionCenterIdFromURI
        }));
  };
  const handleViewClick = (lotNo) => {
    let payload = {
      lotNo : lotNo,
      userId : userid,
      auctionCenterId :auctionCenterIdFromURI,
      userRoleCode : roleCode,
    }
    dispatch(actionUrl.viewBidHistoryRequest(payload));
    setViewModal(true);
  };
  const handleCloseViewModal = () => {
    setViewModal(false);
  };
  const handleExport = (exportType) => {
    setisDownloading(true);
    dispatch(
        actionUrl.fetchBidHistoryRequest({
          sessionType: searchSessionType,
          sessionTime: searchSessionTime,
          lotNo: searchLotNo,
          auctioneerId: searchAuctioneer,
          isExport: 1,
          exportType: exportType,
          userRoleCode : roleCode,
          userId : userid,
          auctionCenterId :auctionCenterIdFromURI
        }));
  };
  const downloadFile = (base64String, fileName, contentType) => {
    // Convert the base64 string to a Blob
    const byteCharacters = atob(base64String);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });

    // Create a link element, hide it, direct download
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);

    // Create a DOMString representing the blob and point the link element towards it
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;

    // Trigger the download
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    setisDownloading(false);
  };
  useEffect(() => {
    if (
      bidHistoryExportData != null &&
      bidHistoryExportData != undefined &&
      bidHistoryExportData != [] && bidHistoryExportData.exportType != undefined
    ) {
        let contentType =
        bidHistoryExportData.exportType == "pdf"
          ? "application/pdf"
          : bidHistoryExportData.exportType == "excel"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "";
      downloadFile(
        bidHistoryExportData?.exported_file,
        "Bid History Report English Auction",
        contentType
      );
      actionUrl.bidHistoryExport([]);
  }
  }, [bidHistoryExportData]);
  useEffect(() => {
    if(userDropdownData){
        setauctioneerList(userDropdownData[0].bidHistoryAuctioneer);
        setlotNoList(userDropdownData[0].bidHistoryLotDto);
        setsessionTimeList(userDropdownData[0].bidHistorySessionTimeDto);
    }
  },[userDropdownData])
  useEffect(() => {
    dispatch(
      actionUrl.fetchBidHistoryRequest({
        auctioneer: null,
        sessionType: null,
        sessionTime: null,
        lotNo: null,
        auctioneerId: searchAuctioneer,
        isExport: 0,
        exportType: "string",
        userRoleCode : roleCode,
        userId : userid,
        auctionCenterId :auctionCenterIdFromURI
      })
    );
    dispatch(actionUrl.fetchBidHistoryDropdownRequest({
        "auctionCenterId": auctionCenterIdFromURI,
        "userId": userid,
        "userRoleCode": roleCode
      }
      ))
  }, []);
  return (
    <>
      
            <div className="row">
              <div className="col-lg-12">
                <div className="row align-items-end">
                <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Auctionner</label>
                      <select
                        className="form-control select-form"
                        value={searchAuctioneer}
                        onChange={(e) => setsearchAuctioneer(e.target.value)}
                      >
                        <option value={0}>Select Auctioneer</option>
                        {auctioneerList?.map((state) => (
                                    <option
                                      key={state.auctioneerId}
                                      value={state.auctioneerId}
                                    >
                                      {state.auctioneer}
                                    </option>
                                  ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Lot No</label>
                      <select
                        className="form-control select-form"
                        value={searchLotNo}
                        onChange={(e) => setsearchLotNo(e.target.value)}
                      >
                        <option value={0}>Select LotNo</option>
                        {lotNoList?.map((state) => (
                                    <option
                                      key={state.lotNo}
                                      value={state.lotNo}
                                    >
                                      {state.lotNo}
                                    </option>
                                  ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Session Time</label>
                      <select
                        className="form-control select-form"
                        value={searchSessionTime}
                        onChange={(e) => setsearchSessionTime(e.target.value)}
                      >
                        <option value={0}>Select Session Time</option>
                        {sessionTimeList?.map((state) => (
                                    <option
                                      key={state.sessionTime}
                                      value={state.sessionTime}
                                    >
                                      {state.sessionTime}
                                    </option>
                                  ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Session Type</label>
                      <select
                        className="form-control select-form"
                        value={searchSessionType}
                        onChange={(e) => setsearchSessionType(e.target.value)}
                      >
                        <option value="">Select Session Type</option>
                        <option value="3">Normal</option>
                        <option value="4">Suppliment</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="BtnGroup">
                      <button
                        onClick={handleSearch}
                        className="SubmitBtn"
                      >
                        Search
                      </button>
                      <button onClick={handleClearSearch}
                        className="SubmitBtn"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 mt-4">
                {loading ? (
                  <>
                    <div className="">
                      <ThreeDots
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        radius="9"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                  </>
                ) : bidHistoryData == [] || bidHistoryData == undefined || bidHistoryData?.length == 0 ? 
                    <>
                        <div className="NoData">No Records Found</div> </> : (
                  <>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Lot No</th>
                          <th>Mark Code</th>
                          <th>Grade Code</th>
                          <th>Status</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                         {bidHistoryData?.map((item, index) => (
                          <tr key={index}>
                            <td>{item.lotNo}</td>
                            <td>{item.markCode}</td>
                            <td>{item.gradeCode}</td>
                            <td>{item.status}</td>
                            <td>
                              <Tooltip title="View" placement="top">
                                <i
                                  className="fa fa-eye"
                                  onClick={() => handleViewClick(item.lotNo)}
                                ></i>
                              </Tooltip>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
                        <button
                          class="SubmitBtn"
                          onClick={() => handleExport("pdf")}
                          disabled={isDownloading}
                        >
                          <i class="fa fa-file-pdf"></i>
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          class="SubmitBtn"
                          onClick={() => handleExport("excel")}
                          disabled={isDownloading}
                        >
                          <i class="fa fa-file-excel"></i>
                        </button>
              </div>
              <div className="col-12">
              <span className="Alert">Data on the screen will appear only on the auction day and after completion of each sessions.</span>
                </div>
            </div>
      {viewModal ? (
        <Modals
          title={"View Bid History"}
          show={viewModal}
          handleClose={handleCloseViewModal}
          size="xl"
          centered
        >
          <div className="row">
            <div className="col-lg-12">
              {viewLoading ? (
                <>
                  <div className="">
                    <ThreeDots
                      visible={true}
                      height="80"
                      width="80"
                      color="#4fa94d"
                      radius="9"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                </>
              ) : (
                <>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Lot No</th>
                        <th>Buyer Name</th>
                        <th>Total No. of Packages</th>
                        <th>Sold Price</th>
                        <th>Status</th>
                        <th>Bid Entry Date & Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewBidHistoryData?.map((item, index) => (
                        <tr key={index}>
                          <td>{item.lotNo}</td>
                          <td>{item.buyerName}</td>
                          <td>{item.totalNoofPackages}</td>
                          <td>{item.soldPrice}</td>
                          <td>{item.status}</td>
                          <td>{item.bidEntryDateandTime}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </Modals>
      ) : (
        ""
      )}
    </>
  );
}

export default BidHistoryPage;
